import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../components/ui/button";
import { Compass, Home, ArrowLeft } from "lucide-react";

/** 404 page dedicated to /dashboard/* unmatched routes.
 *  Avoids silent fallback to "/" so routing bugs surface immediately. */
const NotFoundDashboard = () => {
  const navigate = useNavigate();
  return (
    <div
      className="min-h-screen flex items-center justify-center px-4 bg-gradient-to-b from-slate-50 to-white dark:from-slate-950 dark:to-slate-900"
      data-testid="not-found-dashboard"
    >
      <div className="max-w-md w-full text-center">
        <div className="w-16 h-16 mx-auto rounded-2xl bg-amber-500/10 text-amber-500 flex items-center justify-center mb-5">
          <Compass className="w-8 h-8" />
        </div>
        <h1 className="text-3xl font-bold text-slate-900 dark:text-white mb-2" style={{ fontFamily: 'Outfit' }}>
          Page introuvable dans le tableau de bord
        </h1>
        <p className="text-sm text-slate-500 dark:text-slate-400 mb-6">
          L'URL que vous avez suivie n'existe pas (ou n'existe plus). Aucune
          redirection silencieuse n'a été déclenchée.
        </p>
        <div className="flex flex-col sm:flex-row gap-3 justify-center">
          <Button
            onClick={() => navigate("/dashboard")}
            className="bg-blue-600 hover:bg-blue-700 text-white min-h-[44px]"
            data-testid="notfound-back-to-select"
          >
            <Home className="w-4 h-4 mr-2" />
            Retour à la sélection d'espace
          </Button>
          <Button
            variant="outline"
            onClick={() => navigate(-1)}
            className="min-h-[44px]"
            data-testid="notfound-back"
          >
            <ArrowLeft className="w-4 h-4 mr-2" />
            Page précédente
          </Button>
        </div>
        <p className="mt-6 text-xs text-slate-400">
          Si vous arrivez ici depuis un lien interne d'ALIA,{" "}
          <Link to="/contact" className="underline">signalez-le nous</Link>.
        </p>
      </div>
    </div>
  );
};

export default NotFoundDashboard;
